import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { setTablaLoteria, setGestionLoterias } from '../../../../actions';
import { getLoterias } from '../../../../services/Loterias';
import Swal  from 'sweetalert2';
import { getLoteriasSugeridas, guardarLoteria } from '../../../../services/Loterias';
import { validarSegundaClave } from '../../../../services/Usuario';
import { alerta, toast, cerrarModal } from '../../../../services/utilities';

function Nueva(props){

    useEffect(() => {

        getLoteriasSugeridas().then(response => {
            if(response.status === 200){
                setloteriasSugeridas(response.data.data);
            }else{
                alerta('Error al cargar la lista de loterias sugeridas');
            }
        });

    }, []);

    const [spiner, setSpiner] = useState(false);
    const [verMensaje, setVerMensaje] = useState(false);
    const [loteriasSugeridas, setloteriasSugeridas] = useState([]);
    const [lista_horarios, setListaHorarios] = useState();
    const [captionTableHorarios, setcaptionTableHorarios] = useState('');
    const [btn_guardar, setBtnGuardar] = useState(true);
    const [segundaClave, setSegundaClave] = useState('');

    const [horario_loteria, setHorarioLoteria] = useState({
        "dia_semana": "",
        "hora_inicial": "",
        "hora_final": "",
    });

    const [loteria, setLoteria] = useState({
        "id_loteria_sugerida": "",
        "prefijo":"",
        "oficial":"",
        "sorteos": false,
        "cantidad_sorteos": "",
        "tiempos":"",
        "cantidad_cifras":"",
        "horario_loteria": [],
    });

    

    const handleInputCantidadCifras = (event) => {
        const { name, value } = event.target;

        if(name === 'cantidad_sorteos'){
            const inputValue = value.replace(/\D/g, '');

            if(inputValue === ''){
                setLoteria({ ...loteria, [name]: '' });
                return;
            }

            const cantidadSorteos = Math.min(10, Math.max(1, parseInt(inputValue)));
            setLoteria({ ...loteria, [name]: cantidadSorteos.toString() });
            return;
        }

        setLoteria({ ...loteria, [name]: value });
    };

    const handleInputHorarioChange = (event) => {
        const { name, value } = event.target;
        setHorarioLoteria({ ...horario_loteria, [name]: value });
    };

    const handleInputSegundaClave = (event) => {
        const { name, value } = event.target;
        setSegundaClave(value);
    };

    const handleSelectLoteria = (event) => {

        let id_loteria_sugerida = event.target.value;
        let loteria_selecionada = loteriasSugeridas.find(item => item.id_loteria_sugerida == id_loteria_sugerida);

        if(id_loteria_sugerida.length == 0){

            setLoteria({
                "id_loteria_sugerida" : "",
                "prefijo" :  "",
                "oficial" :  "",
                "sorteos" : false,
                "cantidad_sorteos" : "",
                "tiempos" :  "",
                "cantidad_cifras":"4",
                "horario_loteria": []
            });

            setHorarioLoteria({
                "dia_semana": "",
                "hora_inicial": "",
                "hora_final": ""
            });

            return;
        }

        setLoteria({
            "id_loteria_sugerida" : id_loteria_sugerida,
            "prefijo" :  loteria_selecionada.prefijo,
            "oficial" :  loteria_selecionada.oficial ? 'SI' : 'NO',
            "sorteos" :  loteria_selecionada.sorteos ?? false,
            "cantidad_sorteos" : loteria_selecionada.sorteos ? '1' : '',
            "tiempos" :  loteria_selecionada.tiempos ? 'SI' : 'NO',
            "cantidad_cifras" :  loteria_selecionada.cantidad_cifras,
            "horario_loteria": loteria.horario_loteria
        });

    };

    const handleDelteHorario = (indice) =>{

        let horarios = loteria.horario_loteria
        horarios.splice(indice, 1)
        setListaHorarios(loteria.horario_loteria.map((r, indice) => (
            <tr key={indice} id={'tr-horario-'+indice}>
                <td>
                    {r.dia_semana === "LUNES" && <span className="badge rounded-pill text-bg-dark">{r.dia_semana}</span>}
                    {r.dia_semana === "MARTES" && <span className="badge rounded-pill text-bg-info">{r.dia_semana}</span>}
                    {r.dia_semana === "MIERCOLES" && <span className="badge rounded-pill text-bg-warning">{r.dia_semana}</span>}
                    {r.dia_semana === "JUEVES" && <span className="badge rounded-pill text-bg-danger">{r.dia_semana}</span>}
                    {r.dia_semana === "VIERNES" && <span className="badge rounded-pill text-bg-success">{r.dia_semana}</span>}
                    {r.dia_semana === "SABADO" && <span className="badge rounded-pill text-bg-secondary">{r.dia_semana}</span>}
                    {r.dia_semana === "DOMINGO" && <span className="badge rounded-pill text-bg-primary">{r.dia_semana}</span>}
                </td>
                <td>
                    {r.hora_inicial}
                </td>
                <td>
                    {r.hora_final}
                </td>
                <td>
                    <button 
                        type="button" 
                        className="btn btn-danger btn-sm" 
                        title="Eliminar item" 
                        onClick={() => handleDelteHorario(indice)}>
                        <i className="bi bi-trash"></i>
                    </button>
                </td>
            </tr>
        )))

        setcaptionTableHorarios(loteria.horario_loteria.length == 0 ? '' : 'd-none');
        setBtnGuardar(loteria.horario_loteria.length == 0 ? true : false);
    }

    const handleAgregarHorario = () => {

        if(loteria.id_loteria_sugerida == ''){
            alerta('Seleccione una loteria sugerida', '');
            return;
        }else if(horario_loteria.dia_semana == ''){
            alerta('Seleccione un dia de la semana', '');
            return;
        }else if(horario_loteria.hora_inicial == ''){
            alerta('Debe indicar la hora inicial', '');
            return;
        }else if(horario_loteria.hora_final == ''){
            alerta('Debe indicar la hora final', '');
            return;
        }else if(loteria.horario_loteria.find(item => item.dia_semana === horario_loteria.dia_semana) !== undefined){
            alerta('Ya existe un horario para el dia '+horario_loteria.dia_semana+', por favor seleccione otro dia.','');
            return;
        }

        if(Array.isArray(loteria.horario_loteria)){

            loteria.horario_loteria.push(horario_loteria);
            setListaHorarios(loteria.horario_loteria.map((r, indice) => (
                <tr key={indice} id={'tr-horario-'+indice}>
                    <td>
                        {r.dia_semana === "LUNES" && <span className="badge rounded-pill text-bg-dark">{r.dia_semana}</span>}
                        {r.dia_semana === "MARTES" && <span className="badge rounded-pill text-bg-info">{r.dia_semana}</span>}
                        {r.dia_semana === "MIERCOLES" && <span className="badge rounded-pill text-bg-warning">{r.dia_semana}</span>}
                        {r.dia_semana === "JUEVES" && <span className="badge rounded-pill text-bg-danger">{r.dia_semana}</span>}
                        {r.dia_semana === "VIERNES" && <span className="badge rounded-pill text-bg-success">{r.dia_semana}</span>}
                        {r.dia_semana === "SABADO" && <span className="badge rounded-pill text-bg-secondary">{r.dia_semana}</span>}
                        {r.dia_semana === "DOMINGO" && <span className="badge rounded-pill text-bg-primary">{r.dia_semana}</span>}
                    </td>
                    <td>
                        {r.hora_inicial}
                    </td>
                    <td>
                        {r.hora_final}
                    </td>
                    <td>
                        <button 
                            type="button" 
                            className="btn btn-danger btn-sm" 
                            title="Eliminar item" 
                            onClick={() => handleDelteHorario(indice)}>
                            <i className="bi bi-trash"></i>
                        </button>
                    </td>
                </tr>
            )))

            setcaptionTableHorarios('d-none')
            setBtnGuardar(false);
        }

        setHorarioLoteria({
            "dia_semana": "",
            "hora_inicial": "",
            "hora_final": ""
        });
    }

    const handleRefrescarTablaLoteria = () => {

        getLoterias().then(response => {
            if(response.status === 200){
                props.setTablaLoteria(response.data)
            }else{
                alerta('No se refresco la tabla de loterias, para ver los cambios por favor actulice la pagina.',response.response.data.status_message??response.message,'warning');
            }
        });
    }

    const handleGuardarLoteria = () =>{

        if(loteria.sorteos){
            const cantidadSorteos = parseInt(loteria.cantidad_sorteos);

            if(Number.isNaN(cantidadSorteos) || cantidadSorteos < 1 || cantidadSorteos > 10){
                alerta('La cantidad de sorteos debe estar entre 1 y 10', '');
                return;
            }
        }
        
        Swal.fire({
            title: "¿ Esta seguro de guardar la informaciïón de la loteria ?",
            text: "Si esta seguro presione el boton Guardar de lo contrario Cancelar",
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Guardar'
        }).then((result) => {
            if (result.isConfirmed) {
                guardarLoteria(loteria).then(response => {

                    if(response.status == 201){
                        
                        cerrarModal('modalNuevaLoteria');
                        handleRefrescarTablaLoteria();

                        setListaHorarios(null);
                        setLoteria({
                            "id_loteria_sugerida" : "",
                            "prefijo" :  "",
                            "oficial" :  "",
                            "sorteos" : false,
                            "cantidad_sorteos" : "",
                            "tiempos" : "",
                            "cantidad_cifras":"4",
                            "horario_loteria": []
                        });
                        setBtnGuardar(true);
                        toast('¡ Perfecto !','Loteria creada exitosamente','success');
                    }else{
                        alerta('Se presento un error al intentar guardar la loteria',response.response.data.status_message??response.message);
                    }
                });
            }
        });
    }

    const handleValidarSegundaClave = async () => {

        if(segundaClave.length < 4){
            alerta('Ingrese una clave valida', '');
            return;
        }

        setSpiner(true);
        setVerMensaje(false);

        try {

            await validarSegundaClave(segundaClave).then( response => {
                if(response.status !== undefined && response.status === 200){
                    
                    if(response.data.status_message === 'OK'){
                        props.setGestionLoterias(true);
                        toast('¡ Perfecto !','Clave validada','success');
                    }else{
                        props.setGestionLoterias(false);
                        setVerMensaje(true);
                    }
                }else{
                    alerta('Error al validar la segunda clave en la base de datos');
                }
            });

         }catch (error) {
            alerta('Error no controlado al validar la segunda clave (loterias/nueva/handleValidarSegundaClave) ->'+ error);
        }finally {
            setSpiner(false);
        }
    }
    
    return(
        <React.Fragment>
            <div className="modal fade" id="modalNuevaLoteria" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="modalNuevaLoteria" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="staticBackdropLabel">Crear Nueva loteria</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {props.gestion_loterias ?
                                <>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-floating mb-3">
                                                <select className="form-select" id="id_loteria_sugerida" name="id_loteria_sugerida" aria-label="State" onChange={handleSelectLoteria}>
                                                    <option value="">-- Seleccion --</option>
                                                    {loteriasSugeridas.map(opcion => (
                                                        <option key={opcion.id_loteria_sugerida} value={opcion.id_loteria_sugerida}>{opcion.nombre}</option>
                                                    ))}
                                                </select>
                                                <label htmlFor="id_loteria_sugerida">Loteiras: <span className="text-danger">*</span></label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-floating mb-3">
                                                <input type="text" className="form-control" id="prefijo" value={loteria.prefijo} disabled/>
                                                <label htmlFor="floatingName">Prefijo:</label>
                                            </div>
                                        </div>    
                                        {loteria.tiempos == "SI" || loteria.sorteos ?                                 
                                            <div className="col-md-4">
                                                <div className="form-floating mb-3">
                                                    <input type="number" className="form-control" id="cantidad_cifras" name="cantidad_cifras" onChange={handleInputCantidadCifras}  value={loteria.cantidad_cifras}/>
                                                    <label htmlFor="floatingName">Cantidad de cifras</label>
                                                </div>
                                            </div>
                                        : !loteria.sorteos ?
                                            <div className="col-md-4">
                                                <div className="form-floating mb-3">
                                                    <input type="text" className="form-control" id="oficial"  value={loteria.oficial} disabled/>
                                                    <label htmlFor="floatingName">¿ Es oficial ?</label>
                                                </div>
                                            </div>
                                        : ''
                                        }
                                        {loteria.sorteos ?
                                            <div className="col-md-4">
                                                <div className="form-floating mb-3">
                                                    <input type="number" min="1" max="10" className="form-control" id="cantidad_sorteos" name="cantidad_sorteos" onChange={handleInputCantidadCifras} value={loteria.cantidad_sorteos}/>
                                                    <label htmlFor="cantidad_sorteos">Cantidad de sorteos</label>
                                                </div>
                                            </div>
                                        : ''
                                        }
                                    </div>
                                    <h5 className="card-title text-left">Horario:</h5>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-floating mb-3">
                                                <select className="form-select" value={horario_loteria.dia_semana} id="dia_semana" name="dia_semana" aria-label="State" onChange={handleInputHorarioChange}>
                                                    <option value="">-- Seleccion --</option>
                                                    <option value="DOMINGO">DOMINGO</option>
                                                    <option value="LUNES">LUNES</option>
                                                    <option value="MARTES">MARTES</option>
                                                    <option value="MIERCOLES">MIERCOLES</option>
                                                    <option value="JUEVES">JUEVES</option>
                                                    <option value="VIERNES">VIERNES</option>
                                                    <option value="SABADO">SABADO</option>
                                                </select>
                                                <label htmlFor="dia_semana">Dia: <span className="text-danger">*</span></label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-floating mb-3">
                                                <input type="time" className="form-control" id="hora_inicial" value={horario_loteria.hora_inicial} name="hora_inicial" onChange={handleInputHorarioChange}  />
                                                <label htmlFor="floatingName">Hora Apertura <span className="text-danger">*</span></label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-floating mb-3">
                                                <input type="time" className="form-control" id="hora_final" name="hora_final" value={horario_loteria.hora_final}  onChange={handleInputHorarioChange}  />
                                                <label htmlFor="floatingName">Hora Cierre <span className="text-danger">*</span></label>
                                            </div>
                                        </div>
                                        <div className="col-md-3 pt-3">
                                            <button type="button" className="btn btn-success" onClick={handleAgregarHorario}>Agregar Horario</button>
                                        </div>
                                    </div>
                                    <div className="row p-3">
                                        <table className="table table-sm table-hover table-borderless text-center"style={{ width : "90%"}}>
                                            <caption className={captionTableHorarios}>
                                                <h5 className='text-secondary text-center'>No hay horarios agregadas</h5>
                                            </caption>
                                            <tbody>
                                                {lista_horarios}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            :  
                                <>
                                    <h4 className='text-secondary text-center m-0'>Para continuar por favor ingrese la segunda clave.</h4>
                                    <p className='text-secondary text-center m-0'>Este módulo se encuentra protegido por un doble factor de autenticación.</p>
                                    <br></br>
                                    <div className='row  justify-content-md-center'>
                                        <div className='col-md-4'>
                                            <div className="form-floating mb-3">
                                                <input type="password" className="form-control" id="segunda_clave" name="segunda_clave" value={segundaClave}  onChange={handleInputSegundaClave}  />
                                                <label htmlFor="floatingName">Segunda Clave</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row  justify-content-md-center'>
                                        <div className="col-md-4 text-center">
                                            <button type="button" className="btn btn-success" onClick={handleValidarSegundaClave}>Validar Clave</button>
                                        </div>
                                    </div>
                                    {spiner ?
                                    <div className="d-flex justify-content-center align-items-center my-4">
                                        <div className="spinner-border" role="status"></div>                 
                                    </div>
                                    :''}
                                    {verMensaje ?
                                    <div className='text-center text-danger my-4'>
                                        <h3>Clave incorrecta</h3>
                                        <p>Por favor, ingrese nuevamente la segunda clave de forma correcta.</p>
                                    </div>
                                    :''}
                                </>
                            }
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" disabled={btn_guardar} onClick={handleGuardarLoteria}>Guardar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const mapSateToProps = state => {

    return {
        gestion_loterias: state.gestion_loterias
    }
}

const mapDispatchToProps  = {
    setTablaLoteria,
    setGestionLoterias
};

export default  connect(mapSateToProps, mapDispatchToProps)(Nueva);
